import React from 'react'
import { URLS } from '../../../constants'
import { string } from 'prop-types'
import { Router } from '@reach/router'
import { CartaoCreditoProvider } from '../../../contexts/CartaoCreditoContext'
import TrocarFormaPagamento from './TrocarFormaPagamento/TrocarFormaPagamento'

import HomeBoleto from './PagamentoBoletoBancario'
import BoletoFuturo from './BoletoFuturo/BoletoFuturo'
import LazyComponent from '../../../components/LazyComponent/LazyComponent'

export default function Rotas( { modalidade } ) {
  const routePagamento = modalidade === 'MODALIDADE_CURADORIA' ? URLS.CURADORIA_PAGAMENTO : URLS.INEDITOS_PAGAMENTO

  return (
    <Router>
      <LazyComponent
        Component={ HomeBoleto }
        currentRoute={ routePagamento }
        path="/"
      />
      <LazyComponent
        Component={ BoletoFuturo }
        currentRoute={ routePagamento }
        path="/boleto-futuro"
      />
      <LazyComponent
        Component={ TrocarFormaPagamento }
        Context={ CartaoCreditoProvider }
        currentRoute={ routePagamento }
        path="/trocar-forma-pagamento"
      />
    </Router>
  )
}

Rotas.propTypes = {
  'modalidade': string.isRequired
}
